//
export default {

  /**
   * 
   */
  toHistoric() {
    return [
      {
        text: 'folio',
        value: 'number',
      },
      {
        text: 'sucursal',
        value: 'sl_customer_branch_offices_address',
      },
      {
        text: 'emisión',
        value: 'emission_date',
        align: 'right',
        format: 'date',
      },
      {
        text: 'tipo',
        value: 'documentType',
      },
      {
        text: 'neto',
        value: 'net_total',
        align: 'right',
        format: 'currency',
      },
      {
        text: 'iva',
        value: 'iva',
        align: 'right',
        format: 'currency',
      },
      {
        text: 'total',
        value: 'total',
        align: 'right',
        format: 'currency',
      },
      {
        text: 'vencimiento',
        value: 'account_receivable_pay_date',
        align: 'right',
        format: 'date',
      },
      {
        text: 'pago',
        value: 'account_receivable_real_pay_date',
        align: 'right',
        format: 'date',
      },
      {
        text: 'estado documento',
        value: 'g_state_name',
        align: 'center',
        component: {
          type: 'chip-label',
          props: {
            palette: {
              'no_pagada': 'red lighten-3',
              'pagada': 'success lighten-3',
              'pendiente': 'accent lighten-3',
            },
            small: true,
          },
        },
      },
    ]
  }
}